import type {
	QualityPolygon,
	QualityRectangleFeature,
} from '@/components/map/types/mapFeatureTypes';


const getDrawableQualityPolygons = (item: QualityRectangleFeature): QualityPolygon[] => {
	if (!Array.isArray(item.polygons) || item.polygons.length === 0) {
		return [];
	}
	const polygons: QualityPolygon[] = [];
	for (const polygon of item.polygons) {
		if (polygon == null || !Array.isArray(polygon.rings) || polygon.rings.length === 0) {
			continue;
		}
		const rings = polygon.rings.filter(ring => Array.isArray(ring) && ring.length > 0);
		if (rings.length === 0) {
			continue;
		}
		polygons.push({
			rings: rings,
		});
	}
	return polygons;
};


export {
	getDrawableQualityPolygons,
};
